import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(cards: any, searchText: string): any {
    console.log(cards); //this shows in the console
    console.log(searchText); //this does not show anything in the console when typing
    if (!searchText) {
      return cards;
    }
    return cards.filter((card) => {
      return card.title.toLowerCase().match(searchText.toLowerCase());
    });
  }
}
